import { Para, Stack } from '@drycut/ui-components';
import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
  couponType: string;
  customer?: string;
};

export function CouponSummary({ customer, couponType, className }: Props): React.ReactElement {
  return (
    <Stack gap={2} className={twMerge('text-sm', className)}>
      {customer && (
        <Para>
          <span className="font-aribaubold">Kunde:</span> {customer}
        </Para>
      )}

      <Para>
        <span className="font-aribaubold">Gutschein Typ:</span> {couponType}
      </Para>
    </Stack>
  );
}
